/**
 * Logger shim (Valkyrie port).
 *
 * eb-ui used `@eventbrite/client-logger`, which is dropped in Valkyrie (it
 * depended on the decommissioned real-user-monitoring package — see memory.md
 * drop-recipes). We fall back to `console`, matching the eb-ui behaviour of
 * surfacing errors without failing the flow.
 */
const logger = {
    error: (message: string, context?: Record<string, unknown>): void => {
        // eslint-disable-next-line no-console
        console.error(message, context ?? '');
    },
};

export default logger;
